import React, { useCallback, useState } from 'react'
import { useParams } from 'react-router-dom'

import { AppLayout, FormWrapper, LanguageSelector } from '@/components'
import { ICustomer } from '@/types'
import { t } from '@/i18n'

import { useData } from './useData'
import Form from './form'
import { openInNewTab } from '@/utils'
import { API_ENDPOINT } from '@/constants'
import FileUploaderModal from '@/components/modals/FileUploaderModal'

const EditCustomer: React.FC = () => {
  const { id = '' } = useParams()
  const [isEditing, setIsEditing] = useState<boolean>(false)
  const { data, loading, submitting, onSubmit } = useData({ id })

  const [isUploadingFiles, setIsUploadingFiles] = useState<boolean>(false)

  const onSubmitForm = useCallback(
    (d: ICustomer) => {
      onSubmit(`customers/customers/${id}/`, true, () => setIsEditing(false))(d)
    },
    [id, onSubmit],
  )

  return (
    <AppLayout
      hasFooter
      headerRight={
        <div className="app-right-container">
          <LanguageSelector />
        </div>
      }
    >
      <FormWrapper
        breadcrumbs={[{ name: isEditing ? 'edit_customer' : 'view_customer' }]}
        loading={loading}
        isEditing={isEditing}
        onEdit={() => setIsEditing(true)}
        extraButtons={[
          {
            text: t('גשדגדש'),
            className: 'print-form-button',
            onClick: () =>
              openInNewTab(
                `${API_ENDPOINT}/payment/customer-buyout/${id}/pdf/`,
              ),
          },
          {
            text: t('upload_customer_files'),
            className: 'print-form-button',
            onClick: () => setIsUploadingFiles(true),
          },
        ]}
      >
        <div className="content-box">
          <div className="scroll-wrap">
            <div className="content-title">
              <h2>
                {isEditing
                  ? t('edit_customer_label', { label: data?.id })
                  : t('view_customer')}
              </h2>
            </div>
            <Form
              isEditing={isEditing}
              initialData={data}
              loading={loading}
              submitting={submitting}
              onCancel={() => setIsEditing(false)}
              onSubmit={onSubmitForm}
            />
          </div>
        </div>
      </FormWrapper>

      <FileUploaderModal
        isOpen={isUploadingFiles}
        onClose={() => setIsUploadingFiles(false)}
        contextType="customer"
        contextId={id}
      />
    </AppLayout>
  )
}

export default EditCustomer
